import { snowflakeApi } from '../../utils/api';
import { DatabaseClient, ClientWithStats } from '../../types';

export const clientService = {
  /**
   * Get all clients with their statistics (keyword counts, workflow counts, etc.)
   */
  getClientsWithStats: async (): Promise<ClientWithStats[]> => {
    try {
      const response = await snowflakeApi.get('/api/v1/db/clients/with-stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching clients with stats:', error);
      // Fallback to regular client list if stats endpoint not available
      const fallbackResponse = await snowflakeApi.get('/api/v1/db/clients');
      return fallbackResponse.data.map((client: DatabaseClient) => ({
        ...client,
        keyword_count: 0,
        workflow_count: 0,
        classified_keywords: 0,
        last_activity: new Date().toISOString()
      }));
    }
  },
  
  /**
   * Update client information
   */
  updateClient: async (clientId: number, data: Partial<DatabaseClient>): Promise<DatabaseClient> => {
    const response = await snowflakeApi.put(`/api/v1/db/client/${clientId}`, data);
    return response.data;
  },
  
  /**
   * Get keyword statistics for a specific client (all workflows combined)
   */
  getClientKeywordStats: async (clientId: number) => {
    const response = await snowflakeApi.get(`/api/v1/keywords/statistics/${clientId}`);
    return response.data;
  },

  /**
   * Get keyword statistics for a specific workflow
   */
  getWorkflowKeywordStats: async (clientId: number, workflowId: string) => {
    const response = await snowflakeApi.get(`/api/v1/keywords/statistics/${clientId}/${workflowId}`);
    return response.data;
  },
  
  /**
   * Create a new client
   */
  createClient: async (data: {
    name: string;
    client_code: string;
    industry?: string;
  }): Promise<DatabaseClient> => {
    const response = await snowflakeApi.post('/api/v1/db/client', data);
    return response.data;
  },
  
  /**
   * Get a single client by ID
   */
  getClient: async (clientId: number): Promise<DatabaseClient> => {
    const response = await snowflakeApi.get(`/api/v1/db/client/${clientId}`);
    return response.data;
  },
  
  /**
   * Get workflows for a client
   */
  getClientWorkflows: async (clientId: number) => {
    const response = await snowflakeApi.get(`/api/v1/db/client/${clientId}/workflows`);
    return response.data;
  }
};

export default clientService; 